import { Logger } from './logger';

export let GlobalLogger: Logger;
export function setGlobalLogger(logger: Logger) {
  GlobalLogger = logger;
}
